import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';
// import { User } from '../Utilis/Types/User';
export class FalService extends ApiService {
  static readonly pathName = '/fal';

  static readonly pro = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/pro`, body);
  };

  static readonly pro11 = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/pro-1.1`, body);
  };

  static readonly schnell = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/schnell`, body);
  };

  static readonly dev = (body: {
    flowId: string;
    fileUrl: string;
    prompt: string;
    imageSize: string;
    numInferenceSteps: number;
    seed: number;
    guidanceScale: number;
    syncMode: boolean | string;
    numImages: number;
    safetyTolerance: string;
  }): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/dev`, body);
  };
}
